import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { MessageCircle } from 'lucide-react';
import { gstAPI } from '../../services/api';
import { useGst } from './GstContext';
import { msg } from './gstUi';

// Sends one invoice/note PDF on WhatsApp (from the number connected in the CRM).
export default function GstWhatsappModal({ doc, kind, onClose }) {
  const { call } = useGst();
  const [to, setTo] = useState((doc.party && doc.party.phone) || '');
  const [busy, setBusy] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const b = await call(() => (kind === 'invoice' ? gstAPI.shareInvoice(doc._id, to) : gstAPI.shareNote(doc._id, to)));
      toast.success(`Sent to ${b.data.to}`);
      onClose();
    } catch (err) { toast.error(msg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="modal-overlay">
      <form className="modal" onSubmit={send}>
        <div className="modal-header"><h3>Send {doc.number} on WhatsApp</h3><button type="button" className="modal-close" onClick={onClose}>×</button></div>
        <div className="modal-body">
          <label className="form-label">Mobile number</label>
          <input className="form-control" value={to} onChange={(e) => setTo(e.target.value)} placeholder="10-digit mobile" autoFocus />
          <p style={{ fontSize: 12, opacity: 0.7 }}>The PDF is sent from the CRM&apos;s connected WhatsApp number.</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" disabled={busy || !to.trim()}><MessageCircle size={14} /> {busy ? 'Sending…' : 'Send'}</button>
        </div>
      </form>
    </div>
  );
}
